import {
  VEHICLES_REALTIME_DATA_SUBSCRIBE,
  VEHICLES_REALTIME_DATA_PUBLISH,
  VEHICLES_REALTIME_DATA_FAILURE,
  VEHICLES_REALTIME_DATA_UNSUBSCRIBE,
  VEHICLE_TRACKING_STATUSES_REALTIME_DATA_SUBSCRIBE,
  VEHICLE_TRACKING_STATUSES_REALTIME_DATA_PUBLISH,
  VEHICLE_TRACKING_STATUSES_REALTIME_DATA_FAILURE,
  VEHICLE_TRACKING_STATUSES_REALTIME_DATA_UNSUBSCRIBE,
} from '../actionTypes';

const INITIAL_STATE = {};

export default function vehicleReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case VEHICLES_REALTIME_DATA_SUBSCRIBE:
      return {
        ...state,
        inSyncVehicles: true,
        firstPublish: false,
        syncVehiclesError: null,
      };
    case VEHICLES_REALTIME_DATA_PUBLISH:
      return {
        ...state,
        vehicles: action.data,
        firstPublish: true,
      };
    case VEHICLES_REALTIME_DATA_FAILURE:
      return {
        ...state,
        inSyncVehicles: false,
        vehicles: {},
        syncVehiclesError: action.error,
      };
    case VEHICLES_REALTIME_DATA_UNSUBSCRIBE:
      return {
        ...state,
        inSyncVehicles: false,
        vehicles: {},
        syncVehiclesError: null,
      };
    case VEHICLE_TRACKING_STATUSES_REALTIME_DATA_SUBSCRIBE:
      return {
        ...state,
        inSyncTrackingStatuses: true,
        firstPublishTrackingStatuses: false,
        syncVehicleTrackingStatusError: null,
      };
    case VEHICLE_TRACKING_STATUSES_REALTIME_DATA_PUBLISH:
      return {
        ...state,
        trackingStatuses: action.data,
        firstPublishTrackingStatuses: true,
      };
    case VEHICLE_TRACKING_STATUSES_REALTIME_DATA_FAILURE:
      return {
        ...state,
        inSyncTrackingStatuses: false,
        trackingStatuses: {},
        syncVehicleTrackingStatusError: action.error,
      };
    case VEHICLE_TRACKING_STATUSES_REALTIME_DATA_UNSUBSCRIBE:
      return {
        ...state,
        inSyncTrackingStatuses: false,
        trackingStatuses: {},
        syncVehicleTrackingStatusError: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Vehicle/vehicle.reducer.js